import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import PageTitle from '../components/PageTitle';
import '../components/Layout/layout.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Hero from '../components/Hero';
import Layout from '../components/Layout';
import Link from '../components/Link';
import SidebarMenu from '../components/Layout/Navigation/SidebarMenu';

const TwoColumnList = () => {
  const items = [
    "A. General Information",
    "B. Enrollment and Persistence",
    "C. First-Time, First-Year Admission",
    "D. Transfer Admission",
    "E. Academic Offerings and Policies",
    "F. Student Life",
    "G. Annual Expenses",
    "H. Financial Aid",
    "I. Instructional Faculty and Class Size",
    "J. Degrees Conferred"
  ];

  const midpoint = Math.ceil(items.length / 2);
  const leftColumn = items.slice(0, midpoint);
  const rightColumn = items.slice(midpoint);

  return (
    <div className="row">
      <div className="col-md-6">
        <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
          {leftColumn.map((item, index) => (
            <li key={`left-${index}`}>{item}</li>
          ))}
        </ul>
      </div>
      <div className="col-md-6">
        <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
          {rightColumn.map((item, index) => (
            <li key={`right-${index}`}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const ExpandableSection = ({ isExpanded, children }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState('0px');

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isExpanded ? `${contentRef.current.scrollHeight}px` : '0px');
    }
  }, [isExpanded]);

  return (
    <div
      style={{
        overflow: 'hidden',
        transition: 'max-height 0.5s ease',
        maxHeight: height,
        backgroundColor: '#f8f9fa',
        border: isExpanded ? '1px solid #ddd' : 'none',
        borderTop: 'none',
        borderRadius: isExpanded ? '0 0 4px 4px' : '0',
        marginBottom: isExpanded ? '20px' : '0',
        padding: isExpanded ? '15px 20px' : '0 20px'
      }}
    >
      <div ref={contentRef}>
        {children}
      </div>
    </div>
  );
};


const CommonDataSet = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpanded = () => setIsExpanded(prev => !prev);


  return (
    <Layout upper={<Hero />}>
      <div className="row">
        <div className="col-sm-4 col-lg-3 my-4">
          <SidebarMenu />
        </div>

        <div className="col-sm-8 col-lg-9">
          <PageTitle name="Common Data Set" site="OIRA" />
          <div>
            <p>
              The Common Data Set (CDS) initiative is a collaborative effort among data providers in the higher education community and publishers as represented by the College Board, Peterson's, and U.S. News & World Report. The combined goal of this collaboration is to improve the quality and accuracy of information provided to all involved in a student's transition into higher education, as well as to reduce the reporting burden on data providers.
            </p>
            {/* imported from above */}
            <TwoColumnList />
            <p>Click the red bar to show UA's CDS reports.</p>

            <div
                onClick={toggleExpanded}
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: '#990000',
                    color: 'white',
                    padding: '10px 20px',
                    width: '100%',
                    marginTop: '20px',
                    cursor: 'pointer',
                    userSelect: 'none',
                    fontSize: '1.5em',
                    fontWeight: 'bold'
                }}
                >
                <span>CDS Reports (2015-16 to present)</span>
                <span>{isExpanded ? '−' : '+'}</span>
            </div>
            <ExpandableSection isExpanded={isExpanded}>
                <p>The following reports are available in PDF format.</p>
                <ul>
                    {[
                    {
                        year: "2025-2026",
                        url: "https://oira.ua.edu/d/sites/all/files/reports26/CDS 2025-26 FINAL 9Dec2025.pdf",
                    },
                    {
                        year: "2024-2025",
                        url: "https://oira.ua.edu/d/sites/all/files/reports25/UA%20CDS%202024-25%20FINAL%2022aJan2025.pdf",
                    },
                    {
                        year: "2023-2024",
                        url: "https://oira.ua.edu/d/sites/all/files/reports24/CDS%202023-24%20FINAL.pdf",
                    },
                    {
                        year: "2022-2023",
                        url: "https://oira.ua.edu/d/sites/all/files/reports23/CDS%202022-23%20FINAL.pdf",
                    },
                    {
                        year: "2021-2022",
                        url: "https://oira.ua.edu/d/sites/all/files/reports22/CDS%202021-22%20FINAL.pdf",
                    },
                    {
                        year: "2020-2021",
                        url: "https://oira.ua.edu/d/sites/all/files/reports21/THE%20CDS%202020-21%20FINAL.pdf",
                    },
                    {
                        year: "2019-2020",
                        url: "https://oira.ua.edu/d/sites/all/files/reports20/THE%20CDS%202019-20%20FINAL.pdf",
                    },
                    {
                        year: "2018-2019",
                        url: "https://oira.ua.edu/d/sites/all/files/reports19/THE%20CDS%202018-19%20FINAL.pdf",
                    },
                    {
                        year: "2017-2018",
                        url: "https://oira.ua.edu/d/sites/all/files/reports18/1718_cds.pdf",
                    },
                    {
                        year: "2016-2017",
                        url: "https://oira.ua.edu/d/sites/all/files/reports17//1617_cds.pdf",
                    },
                    {
                        year: "2015-2016",
                        url: "https://oira.ua.edu/d/sites/all/files/reports16//1516_cds.pdf",
                    },
                    ].map((report, index) => (
                    <li key={index}>
                        <a href={report.url} target="_blank" rel="noopener noreferrer">
                        CDS {report.year}
                        </a>
                    </li>
                    ))}
                </ul>
                <p>&nbsp;</p>
            </ExpandableSection>
          </div>
        </div>
      </div>
    </Layout>
  );
};

const HoverLink = styled(Link)`
  display: inline-block;
  padding: 10px;
  background-color: #ffffff;
  color: #990000;
  text-decoration: none;
  border-radius: 5px;
  border: 2px solid #990000;
  text-align: center;
  font-family: Roboto, Verdana, Helvetica, sans-serif;
  transition: all 0.3s ease;

  &:hover {
    font-weight: bold;
    color: #ffffff;
    background-color: #990000;
  }
`;

export default CommonDataSet;
